import React, { cloneElement, useState } from "react";
import PropTypes from "prop-types";
import { Layout, Card, Divider, Tooltip, Button, Popconfirm } from "antd";
const { Sider, Content } = Layout;
import { DeleteOutlined, PlusOutlined, MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import LoadingWrapper from "./loading-wrapper";

const Workspace = ({
  projects,
  currentProject,
  disabled,
  title,
  extraActions,
  onSelectProject,
  onCreateProject,
  onDeleteProject,
  children,
  // controlled mode for list visibility
  listVisible = false,
  setListVisible,
  listItemRenderer,
  loading = false,
}) => {
  const [siderVisible, setSiderVisible] = useState(listVisible);
  const toggleListVisible = setListVisible ? setListVisible : () => setSiderVisible(!siderVisible);
  const siderDisplay = (setListVisible ? listVisible : siderVisible) ? "block" : "none";
  return (
    <Layout>
      <Content style={{ position: "relative" }}>
        <div style={{ position: "absolute", right: 0, top: 0, display: "flex", flexDirection: "row-reverse", gap: 8, padding: 8 }}>
          <Tooltip title="Toggle Project List">
            <Button
              onClick={toggleListVisible}
              disabled={disabled}
              icon={siderVisible ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />} />
          </Tooltip>
          <Tooltip title="Create New Project">
            <Button
              onClick={onCreateProject}
              disabled={disabled}
              icon={<PlusOutlined />} />
          </Tooltip>
          {currentProject && currentProject.id ? (
            <Popconfirm
              onConfirm={() => onDeleteProject(currentProject)}
              placement="bottom"
              title="Delete this project?"
              okText="Yes"
              cancelText="No"
            >
              <Tooltip title="Delete Project">
                <Button icon={<DeleteOutlined />} danger={true} />
              </Tooltip>
            </Popconfirm>
          ) : null}
          {extraActions && extraActions.length > 0
            ? extraActions.map((action, i) => cloneElement(action, { project: currentProject, key: `${currentProject?.id}_${i}` }))
            : null}
        </div>
        {cloneElement(children, { project: currentProject, key: currentProject?.id })}
      </Content>
      <Sider width={200} style={{ backgroundColor: "rgba(235,235,235)", padding: 16, minHeight: "100vh", display: siderDisplay }}>
        <h2>{title}</h2>
        <Divider />
        <LoadingWrapper loading={loading}>
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            {(projects || []).map(project => (
              <Card
                key={project.id}
                onClick={() => onSelectProject(project)}
                hoverable={true}
                styles={{ body: { padding: 8 } }}
                style={{ backgroundColor: project.id === currentProject?.id ? "#1890ff30" : "rgba(245,245,245)" }}
              >
                {listItemRenderer ? listItemRenderer(project) : (
                  <div style={{ width: "100%", maxHeight: 84, textOverflow: "ellipsis" }}>
                    <b>{project.name}</b>
                  </div>
                )}
              </Card>
            ))}
          </div>
        </LoadingWrapper>
      </Sider>
    </Layout>
  );
};

Workspace.propTypes = {
  projects: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  })).isRequired,
  currentProject: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string
  }),
  title: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  extraActions: PropTypes.arrayOf(PropTypes.element),
  onSelectProject: PropTypes.func.isRequired,
  onCreateProject: PropTypes.func.isRequired,
  onDeleteProject: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired,
  listVisible: PropTypes.bool,
  setListVisible: PropTypes.func,
  listItemRenderer: PropTypes.func,
  loading: PropTypes.bool,
};

export default Workspace;